import React from "react";

import svg from "../../assets/images/icons/RichText/full_screen.svg";

export const TableIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Table"}
    />
);
